import qs from "query-string";
import { useEffect, useState } from "react";

import useService from "../../../../hooks/useService";
import {
  formatPaymentMethodOptions,
  PAYMENT_METHOD_QUERY_PARAMS,
} from "../utils/paymentFormUtils";

export default function usePaymentMethodOptions(openModal) {
  const enumRepository = useService("repositories/enum-repository");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!openModal) {
      return;
    }

    const fetchOptions = async () => {
      const urlPath = `field_options/?${qs.stringify(PAYMENT_METHOD_QUERY_PARAMS)}`;
      const response = await enumRepository.query({ urlPath });
      setOptions(formatPaymentMethodOptions(response ?? []));
    };

    fetchOptions();
  }, [enumRepository, openModal]);

  return options;
}
